/* theme.js — bootstrap global EDJ */

(function () {
  'use strict';
  window.EDJ = window.EDJ || {};

  // Event bus
  const listeners = new Map();
  EDJ.events = {
    on(event, handler) {
      if (!listeners.has(event)) listeners.set(event, new Set());
      listeners.get(event).add(handler);
      return () => listeners.get(event)?.delete(handler);
    },
    emit(event, detail) {
      listeners.get(event)?.forEach(h => {
        try { h(detail); } catch (e) { console.error(`[EDJ] ${event}:`, e); }
      });
      document.dispatchEvent(new CustomEvent(`edj:${event}`, { detail, bubbles: true }));
    }
  };

  // Consent stub (Lot 8)
  EDJ.consent = { has: () => true };

  // Focus trap utility
  EDJ.trapFocus = function (element) {
    const focusable = element.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return () => {};
    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function handle(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    element.addEventListener('keydown', handle);
    first.focus();
    return () => element.removeEventListener('keydown', handle);
  };

  console.debug('[EDJ] theme.js loaded');
})();
